import { useNavigate, useLocation } from "react-router-dom";
import { Button, Text } from "@primer/react";
import { ChevronLeftIcon } from '@primer/octicons-react';

export const useSafeNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const goBackOrFallback = (fallbackPath: string) => {
    const hasInternalNavigation = location.state?.fromInternal;

    const referrer = document.referrer;
    const currentOrigin = window.location.origin;
    const isFromSameOrigin = referrer.startsWith(currentOrigin);

    const hasHistory = window.history.length > 1;

    if (hasInternalNavigation || (isFromSameOrigin && hasHistory)) {
      navigate(-1);
    } else {
      navigate(fallbackPath);
    }
  };

  return { goBackOrFallback };
};

// Хук для навигации, вернуть назад или на другую страницу
export const useInternalNavigation = () => {
  const navigate = useNavigate();

  const navigateInternal = (to: string, options?: any) => {
    navigate(to, {
      ...options,
      state: { ...options?.state, fromInternal: true }
    });
  };

  return { navigateInternal };
};

export const BackComponent = ({ fallbackPath, isOnlyFallback }: { fallbackPath: string, isOnlyFallback: boolean }) => {
  const { goBackOrFallback } = useSafeNavigation();
  const navigate = useNavigate();

  const handleBack = () => {
    if (isOnlyFallback) {
      navigate(fallbackPath);
    } else {
      goBackOrFallback(fallbackPath);
    }
  };

  return (
    <Button
      leadingVisual={ChevronLeftIcon}
      variant='invisible'
      onClick={handleBack}>
      <Text className='block mb-[1.5px]'>Назад</Text>
    </Button>
  );
};